const MATERIALS_AIR_DUCTS = [
  // Eco
  {
    url: "https://www.vedinimas.lt/ortakis-ductus-basic-75-antibakterinis-antistatinis-d75mm-50m-rulonas-lightgreen-spalvos",
    icon: "https://www.vedinimas.lt/images/uploader/or/588x588.g/ortakis-ductus-75-antibakterinisantistatinis-d75mm-50m-rulonas-lightgreen-spalvos-3-1.jpg",
    code: "904000010",
    name: "Vėdinimo ortakis Ductus 75 AB AS 50m",
    multiplier: 1,
    productGroup: "normal",
    good_id: 47580,
  },
  {
    url: "https://www.vedinimas.lt/mm-75-mova-ortakiui-75-63",
    icon: "https://www.vedinimas.lt/images/uploader/mm/500x500.g/mm-75-mova-ortakiui-7563-1.jpg",
    code: "900000003",
    name: "Mova ortakiui 75/63 mm MM-75",
    multiplier: 1,
    productGroup: "normal",
    good_id: 46781,
  },
  {
    url: "https://www.vedinimas.lt/laikiklis-fast-75-ortakiui-75-10-vnt-pakuote",
    icon: "https://www.vedinimas.lt/images/uploader/la/588x588.g/laikiklis-fast-75-ortakiui-o75-10-vnt-pakuote-1-1.jpg",
    code: "900000021",
    name: "Laikiklis FAST-75 ortakiui Ø75, 10 vnt pakuotė",
    multiplier: 5,
    productGroup: "normal",
    good_id: 47961,
  },
  // Premium
  {
    url: "https://www.vedinimas.lt/lankstus-ortakis-ductus-pro-75-antibakterinis-antistatinis-antigrybelinis-sidabro-jonai-50m-rulonas-turkio-spalvos",
    icon: "https://www.vedinimas.lt/images/uploader/la/588x588.g/lankstus-ortakis-ductus-pro-75-antibakterinis-antistatinis-antigrybelinis-sidabro-jonai-50m-rulonas-turkio-spalvos-3-1.jpg",
    code: "039173302",
    name: "Vėdinimo ortakis Ductus Pro 75 AB AS 50m",
    multiplier: 1,
    productGroup: "premium",
    good_id: 47349,
  },
  {
    url: "https://www.vedinimas.lt/mm-75-mova-ortakiui-75-63",
    icon: "https://www.vedinimas.lt/images/uploader/mm/500x500.g/mm-75-mova-ortakiui-7563-1.jpg",
    code: "900000003",
    name: "Mova ortakiui 75/63 mm MM-75",
    multiplier: 1,
    productGroup: "premium",
    good_id: 46781,
  },
  {
    url: "https://www.vedinimas.lt/laikiklis-fast-75-ortakiui-75-10-vnt-pakuote",
    icon: "https://www.vedinimas.lt/images/uploader/la/588x588.g/laikiklis-fast-75-ortakiui-o75-10-vnt-pakuote-1-1.jpg",
    code: "900000021",
    name: "Laikiklis FAST-75 ortakiui Ø75, 10 vnt pakuotė",
    multiplier: 5,
    productGroup: "premium",
    good_id: 47961,
  }
];

export default MATERIALS_AIR_DUCTS;
